var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inquiry"},[_c('Header',{ref:"header",attrs:{"title":_vm.title},on:{"backPage":_vm.onBackPage}}),_c('From',{ref:"memu",on:{"submit":_vm.handleSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }